import React, {forwardRef} from 'react';
import {Button, Dropdown} from 'react-bootstrap';
import {Formik} from 'formik';
import moment from 'moment';
import * as actions from '../../../_redux/paymentsActions';
import can from '../../../../_common/components/Permissions/can';
import SelectDate from '../../../../_common/components/SelectDate';
import {toAbsoluteUrl} from '../../../../../../_metronic/_helpers';
import styles from './styles.module.scss';

const CustomDDToggle = ({tooltip, cellContent}) => forwardRef(({onClick}, ref) => (
  <Button
    className={`btn btn-icon btn-light btn-sm mx-3 custom-action-button ${cellContent.statusID === 8 ? `` : `custom-disabled-button`}`}
    ref={ref}
    onClick={onClick}
    title={tooltip}
    disabled={!(cellContent.statusID === 8 && can('full', 'bituahLeumiPayment'))}
  >
    <img
      src={toAbsoluteUrl('/media/svg/Calendar_brandColor.svg')}
      alt="update"
      className="w-20px"
    />
  </Button>
));

const CustomMenu = React.forwardRef(
  ({children, style, className, 'aria-labelledby': labeledBy}, ref) => {
    return (
      <div
        ref={ref}
        className={className}
        aria-labelledby={labeledBy}
        id={'custom-dd-menu'}
      >
        {React.Children.toArray(children)}
      </div>
    );
  },
);

export function SetBirthDateColumnFormatter(cellContent, intl, dispatch) {
  const tooltip = intl.formatMessage({
    id: 'automatedPayments-tooltip-setBirthDate',
    defaultMessage: 'Set birth date',
  });

  return (
    <Formik
      initialValues={{date: new Date()}}
      onSubmit={() => null}
      enableReinitialize={true}
    >
      {({
          values,
          setFieldValue,
          handleSubmit
        }) => (
        <form onSubmit={handleSubmit}>
          <Dropdown
            autoClose="outside"
            onToggle={isOpen => {
              const {date, birthDate} = values;
              const isNotSameDates = !moment(date).isSame(birthDate, 'day');
              if (!isOpen && date && birthDate && isNotSameDates) {
                dispatch(actions.addBirthDateAction(
                  cellContent?.agentID,
                  Date.parse(moment(birthDate).format('YYYY-MM-DD'))
                ))
              }
            }}
          >
            <Dropdown.Toggle as={CustomDDToggle({tooltip, cellContent})} />
            <Dropdown.Menu as={CustomMenu} >
              <Dropdown.Item
                onClick={e => {
                  e.preventDefault();
                }}
                className={styles.ddItem}
              >
                <SelectDate
                  value={values.birthDate}
                  saveOnBlur={false}
                  onChange={(date) => {
                    setFieldValue('birthDate', date);
                  }}
                  onSave={(date) => {
                    setFieldValue('birthDate', date);
                  }}
                />
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </form>
      )}
    </Formik>
  );
}
